import * as API from 'constants/API'

import * as atypes from '../flowPlayerReduxActionTypes'

export const fetchSharedFlow = (share_hash) => {
  return (dispatch, getState) => {
    const { flowPlayer } = getState()

    if (flowPlayer.data === null && !flowPlayer.fetching) {
      dispatch({
        type: atypes.FLOWPLAYER_FLOW_DATA_FETCH,
        $fetch: API.fetchSharedFlow.replace(':share_hash', share_hash),
        $error: () => {
          console.warn('Flow unavailable')
        },
      })
    }
  }
}
